import { useLanguage } from "@/contexts/LanguageContext";

const DataBar = () => {
  const { t } = useLanguage();

  const metrics = [
    { value: "50,000+", label: t.dataBar.listings },
    { value: "15+", label: t.dataBar.neighborhoods },
    { value: "24h", label: t.dataBar.updated },
    { value: "EU", label: t.dataBar.platform },
  ];

  return (
    <section className="bg-primary/5 border-y border-border">
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-border">
          {metrics.map((m, i) => (
            <div key={i} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-foreground">{m.value}</div>
              <div className="text-xs md:text-sm text-muted-foreground mt-0.5">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DataBar;
